export default __webpack_public_path__ + "static/media/sports01.22c5dac4.png";